module.exports = __webpack_public_path__ + "static/img/Gacha10.1da66f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha10.png
// module id = SJ3L
// module chunks = 1